// GB-API (CoreAPI) Shiro rights the app checks. All of them are requested in one user-rights/check call at startup.
export enum GbApiUserRightEnum {
    BundlesView = 'bundles:browse:options:selection:read', // Bundle Inspector
    BundlesManage = 'bundles:manage',   // Detaching elements from a bundle; CoreAPI's detach endpoint checks it too
    // CoreAPI rooms/update checks no right, so the client gates note editing with the right CoreClient effectively uses.
    // Switch to a dedicated right (e.g. room:comment:update) once CoreAPI has one.
    RoomNotesEdit = 'coreclient:apartments'
}

export type GbApiUserRights = Partial<Record<GbApiUserRightEnum, boolean>>;
